import Helmet from 'react-helmet'
import React from 'react'

export const SEO = ({
                        image,
                        title,
                        ogTitle,
                        description,
                        url,
                        type,
                        siteName,
                        keywords,
                        robots,
                        useProtocol
                    }) => {
    return (
        <Helmet title={ogTitle || 'Venrock'}>
            {description &&
                <meta data-react-helmet="true" name='description' content={description || 'Venrock Description'}/>
            }
            {description &&
                <meta data-react-helmet="true" name='og:description' content={description || 'Venrock Description'}/>
            }
            <meta data-react-helmet="true" name='twitter:title' content={ogTitle || 'Venrock'}/>
            {description &&
                <meta data-react-helmet="true" name='twitter:description'
                      content={description || 'Venrock Description'}/>
            }
            {image &&
                <meta data-react-helmet="true" name='twitter:image' content={useProtocol ? `https://${image}` : image}/>
            }
            {/*<meta data-react-helmet="true" name='twitter:card' content='summary'/>*/}
            {/*<meta data-react-helmet="true" name='twitter:url' content={url}/>*/}
            <meta data-react-helmet="true" property='og:title' content={ogTitle || 'Venrock'}/>
            {image &&
                <meta data-react-helmet="true" property='og:image' content={useProtocol ? `https://${image}` : image}/>
            }
            {url &&
                <meta data-react-helmet="true" property='og:url' content={url}/>
            }
            {type &&
                <meta data-react-helmet="true" property='og:type' content={type}/>
            }
            <meta data-react-helmet="true" property='og:site_name' content={siteName || 'Venrock'}/>
            {keywords &&
                <meta data-react-helmet="true" name='keywords' content={keywords}/>
            }
            {robots &&
                <meta data-react-helmet="true" name='robots' content={robots}/>
            }
            <meta data-react-helmet="true" name='viewport'
                  content='width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0'/>
        </Helmet>
    )
}